<template>
    <div>
        <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
            <el-breadcrumb-item>设置客服</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input placeholder="请输入客服帐号" clearable v-model="queryInfo.query" @clear="getList()">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="12"><el-button type="primary" @click="addDialogVisible = true">添加客服</el-button></el-col>
            </el-row>
            <!--搜索与添加区域-->
            <!--商品列表区域-->
            <el-table :data="list" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="ID" type="index" width="100"></el-table-column>
                <el-table-column label="客服名称" prop="name" width="200"></el-table-column>
                <el-table-column label="帐号" prop="username" width="200"></el-table-column>
                <!-- <el-table-column label="密码" prop="password" width="150"></el-table-column> -->
                <el-table-column label="IP" prop="ip" width="600"></el-table-column>
                <el-table-column label="状态" prop="status" width="100">
                    <template slot-scope="scope">
                       <el-tag v-if="scope.row.status=='0'"  type="success">正常</el-tag>
                       <el-tag v-if="scope.row.status=='1'" type="info">禁用</el-tag>
                       <!-- <el-tag v-else-if="scope.row.isopen=='3'" type="warning">装修中</el-tag> -->
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <!--作用域插槽-->
                    <template slot-scope="scope" v-if="scope.row.username !='admin'">
                        <!-- {{scope.row}} -->
                        <el-button type="success" icon="el-icon-edit" size="mini" @click="EditMerchant(scope.row.id)"></el-button>
                        <!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelMerchant(scope.row.id)"></el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!--商品列表区域-->
             <!--分页区域-->
             <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加对话框-->
            <el-dialog title="添加客服" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="addForm.username"  placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model="addForm.password" type="password"  placeholder="请输入密码" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="客报名称" prop="name">
                        <el-input v-model="addForm.name" placeholder="请输入客报名称"></el-input>
                    </el-form-item>
                    <el-form-item label="IP" prop="ip">
                        <el-input v-model="addForm.ip" placeholder="请输入IP地址"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-switch active-value="1" inactive-value="0" v-model="addForm.status"></el-switch>
                        <span style="padding-left: 10px;" v-if="addForm.status == '0'">正常</span>
                        <span style="padding-left: 10px;" v-if="addForm.status == '1'">禁用</span>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="AddMerchant">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加对话框-->
            <!--编辑对话框-->
            <el-dialog title="编辑客服" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="editForm.username" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password1">
                        <el-input v-model="editForm.password1"  placeholder="如果为空则使用原密码"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="editForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="IP" prop="ip">
                        <el-input v-model="editForm.ip"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-switch active-value="1" inactive-value="0" v-model="editForm.status"></el-switch>
                        <span style="padding-left: 10px;" v-if="editForm.status == '0'">正常</span>
                        <span style="padding-left: 10px;" v-if="editForm.status == '1'">禁用</span>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="EditMerchantSave(editForm.id)">确 定</el-button>
                </span>
            </el-dialog>
            <!--编辑对话框-->
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return{
            
            imgURL:this.GLOBAL.imgURL,
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 20
            },
            total:0,
            list: [],
            perids:[],
            addDialogVisible:false,
            editDialogVisible:false,
            addForm:{
                 username:'',
                 password:'',
                 name:'',
                 ip:'',
                 status:''
            },
             //编辑表单数据
             editForm:{
                username:'',
                password1:'',
                name:'',
                ip:'',
                status:''
            },
            //添加表单验证规则
            addFormRules:{
                username:[
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { min: 5, max: 20, message: '用户名长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                password:[
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                name:[
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                ip:[
                    { required: true, message: '请输入ip地址', trigger: 'blur' }
                ],
            },
            editFormRules:{
                name:[
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                ip:[
                    { required: true, message: '请输入ip地址', trigger: 'blur' }
                ]
            },
        }
        
    },
    created() {
         this.getList()
    },
    mounted(){
        this.addForm.admin_token = window.sessionStorage.getItem('admin_token') 
    },
    
    methods:{

        async getList() {
            const { data:res } = await this.$http.get('servicelist/',{ params: this.queryInfo })
            if(res.status == 1){
                this.total = res.data.totalCount;
                this.list = res.data.list.map(v => {
                //在返回的数据里增加一条数据
                // console.log(v.fields)
                return v.fields
                })
            }
            for (let index = 0; index < res.data.list.length; index++) {
                this.list[index].id= res.data.list[index].pk;
            }
        },
        handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getList()
       },
       handleCurrentChange(newPage){
          // console.log(newPage)
           this.queryInfo.pagenum = newPage
           this.getList()
       },
       addDialogClosed(){
            this.$refs.addFormRef.resetFields()
       },
       editDialogClosed(){
            this.$refs.editFormRef.resetFields()
       },
       AddMerchant(){
        this.$refs.addFormRef.validate( async valid=>{
                if (!valid) return
                console.log(this.addForm);
                const { data:res } = await this.$http.post('serviceadd/',this.addForm)
                if(res.status===0)
                {
                    this.$message.success('添加客服成功！')
                    this.addDialogVisible = false
                    this.getList()
                }
                if(res.status == 1){
                    this.$message.error('此用户名已存在')
                }
              })
       },
       async EditMerchant(id){
           const { data: res } = await this.$http.get('serviceinfo/'+id)
            this.editDialogVisible = true
            this.editForm = res;
            this.editForm.admin_token =window.sessionStorage.getItem('admin_token')
       },
       EditMerchantSave(id){
           this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                const { data: res } = await this.$http.post('serviceedit/' + id,this.editForm)
                if (res.status === 0) {
                    this.$message.success('客服修改成功')
                    this.editDialogVisible = false
                    this.getList()
                }
            })
       },
       async DelMerchant(id){
                const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).catch(err => err)

                    if (confirmResult !== 'confirm'){
                        return this.$message.info('已取消删除！')
                    }
                    const { data: res } = await this.$http.get('/servicedel/'+ id)
                
                    if (res.status === 0) { 
                        this.$message({message: '删除成功！',type: 'success'})
                    }
                    this.getList()
       },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
        height: 0px;
    }

</style>